import React, { useState } from "react"
import { useFormContext } from "react-hook-form"

import Button from "src/components/Button"
import ContactBoatPicker from "src/components/ContactBoatPicker"
import PickerSubmitError from "src/components/ContactBoatPicker/PickerSubmitError"
import {
  emptyContact,
  emptyContactBoat,
} from "src/components/ContactBoatPicker/emptyShapes"
import parseResolveError from "src/components/ContactBoatPicker/parseResolveError"
import useContactBoatPicker, {
  PANEL_CREATE_BOAT,
  PANEL_CREATE_BOTH,
  PANEL_NONE,
} from "src/components/ContactBoatPicker/useContactBoatPicker"

import { VALIDATED_FIELDS_BY_TAB } from "../../../constants"
import PageActions from "../../wizard/PageActions"
import PricingSummary from "./PricingSummary"

const ContactAndBoat = () => {
  const { watch, trigger, getValues } = useFormContext()
  const picker = useContactBoatPicker({
    initialContactName: getValues("contact.name") || "",
    emptyContact,
    emptyContactBoat,
  })
  const [selectedContactId, selectedBoatId] = watch([
    "contact_id",
    "contact_boat_id",
  ])
  const [pickerSubmitError, setPickerSubmitError] = useState(null)

  const inInlineCreate =
    picker.panel === PANEL_CREATE_BOTH || picker.panel === PANEL_CREATE_BOAT

  const saveInlineCreate = async () => {
    setPickerSubmitError(null)
    try {
      await picker.resolveSelection(getValues())
    } catch (error) {
      const parsed = parseResolveError(error)
      if (parsed) setPickerSubmitError(parsed)
    }
  }

  const advanceFromTab = async () => {
    if (picker.isWorking || picker.panel !== PANEL_NONE) return false
    return trigger(VALIDATED_FIELDS_BY_TAB.contactAndBoat)
  }

  const saveButtonLabel =
    picker.panel === PANEL_CREATE_BOTH
      ? picker.includeBoatInCreate
        ? "Save Boat and Contact"
        : "Save Contact"
      : "Save Boat"

  return (
    <>
      <ContactBoatPicker handle={picker} />
      {inInlineCreate ? (
        <div className="mt-4 flex flex-col gap-4">
          <Button
            variant="primary"
            onClick={saveInlineCreate}
            disabled={picker.isWorking}
          >
            {saveButtonLabel}
          </Button>
          <PickerSubmitError submitError={pickerSubmitError} />
        </div>
      ) : null}
      {selectedContactId && selectedBoatId && picker.panel === PANEL_NONE ? (
        <PricingSummary />
      ) : null}
      <PageActions pageValidation={advanceFromTab} />
    </>
  )
}

export default ContactAndBoat
